import './InmaculadaPageStyle.scss';
import { useState, useEffect } from "react";
import { getInmaculadaAEquipos, getPartidoSiguienteInmaculadaA, getInmaculadaAJornadas, getInmaculadaAPatrocinadores } from '../firebase-service/firebaseService.js'
import React  from 'react';
import BurgerMenu from '../component/Burger-menu';

export function InmaculadaAPage() {
    
    const [equipos, setEquipos] = useState([]);
    const [jornadas, setJornadas] = useState([]);
    const [patrocinadores, setPatrocinadores] = useState([]);
    const [jornadaActual, setJornadaActual] = useState([]);
    const [atLeastOneResult, setAtLeastOneResult] = useState(false);


    const esperarPorEquipos = async () => {
        getInmaculadaAEquipos(resp => {
            if (resp.length > 0) { 
                setEquipos(resp)
            }
            if (resp.length === 0) { setEquipos([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorJornadas = async () => {
        getInmaculadaAJornadas(resp => {
            if (resp.length > 0) {
                resp = resp.sort((a,b) => b.nJornada - a.nJornada) 
                setJornadas(resp)
                esperarPorPartidoSiguiente(resp)
                getAtLeastOneResult(resp)
            }
            if (resp.length === 0) { setJornadas([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorPatrocinadores = async () => {
        getInmaculadaAPatrocinadores(resp => {
            if (resp.length > 0) { 
                resp = resp.filter((a) => a.orden != -1)
                resp = resp.sort((a,b) => a.orden - b.orden)
                setPatrocinadores(resp)
            }
            if (resp.length === 0) { setPatrocinadores([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorPartidoSiguiente = async (respJornadas) => {
        getPartidoSiguienteInmaculadaA(resp => {
            getJornadaActual(respJornadas,resp)
        }, (resp, err) => { console.error(resp, err) })
    };

    useEffect(() => {
        esperarPorEquipos()
        esperarPorPatrocinadores()
        esperarPorJornadas()  
    }, []);

    const getJornadaActual = (jornadasTotal,partidoSig) =>{ 
        jornadasTotal.map((jornada)=>{
            if(jornada.nJornada === partidoSig.jornada){
                setJornadaActual(jornada)
                console.log(jornada)
            }
        }) 
    }

    const getImagenEquipo = (nombreEquipo) =>{
        let urlEscudo=""
        equipos.map((equipo)=>{
            if(equipo.nombre === nombreEquipo){
                urlEscudo = equipo.escudoUrl
            }
        })
        return urlEscudo
    }

    const getAtLeastOneResult = async (respJornadas)  =>{
        var tmp = false
        respJornadas.map((jornada) => {
            if (jornada.puntosLocal !== "-"){
                setAtLeastOneResult(true)
                tmp = true
            }
        })
        if(tmp === false){
            setAtLeastOneResult(false)
        }
    }
    

    return (
        <main className="main">
           <div className="page-title-container">
                <div className="page-title-text">
                    A.A. INMACULADA 'A' - RV MEDICINA ESTETICA
                </div>
           </div>
           <div className="actual-match-container">
                <div className='actual-match-number'>
                    Siguiente partido
                </div>
                <div className='actual-match-details'>
                    <div className="team-container">
                        <img src={getImagenEquipo(jornadaActual.equipoLocal)} className="team-image" alt="escudo" />
                    </div>
                    <div className='actual-match-date'>
                        <div className='title-date'>
                            {"JORNADA " + jornadaActual.nJornada}
                        </div>
                        <div className='title-date'>
                            FECHA
                        </div>
                        <div className='text-date'>
                            {jornadaActual.fecha}
                        </div>
                        <div className='text-date'>
                            {jornadaActual.hora}
                        </div>
                        <div className='title-date'>
                            LUGAR
                        </div>
                        <div className='text-date'>
                            {jornadaActual.campo}
                        </div>
                    </div>
                    <div className="team-container">
                            <img src={getImagenEquipo(jornadaActual.equipoVisitante)} className="team-image" alt="escudo" />
                    </div>
                </div>
           </div>

           {atLeastOneResult && <div className='section-title'>
                <div className='title'>
                    Últimos resultados
                </div>
           </div>}
           
            <div className="last-results-container">
                { jornadas.map((jornada) => {
                    if (jornada.puntosLocal !== "-"){
                        if((jornada.equipoLocal === "A.A. INMACULADA - A" && jornada.puntosLocal>jornada.puntosVisitante) ||
                            (jornada.equipoVisitante === "A.A. INMACULADA - A" && jornada.puntosVisitante>jornada.puntosLocal)){
                            return (<div className='row-result-win' key={jornada.fecha}>
                                <div className="text-result-container">
                                    <div className="text-result">
                                        Victoria
                                    </div>
                                </div>
                                <div className="column-teams-result">
                                    <div className="date-text" >{jornada.fecha}</div>
                                    <div className="container-teams-result">
                                        <div className="team-image-result">
                                            <img src={getImagenEquipo(jornada.equipoLocal)} className="team-image" alt="escudo" />  
                                        </div>
                                        <div className="separator" >VS</div>
                                        <div className="team-image-result">
                                            <img src={getImagenEquipo(jornada.equipoVisitante)} className="team-image" alt="escudo" />  
                                        </div>
                                    </div>
                                </div>
                                <div className="number-result-container">
                                    <div className="number-result">
                                        <div className="team-result">
                                                {jornada.puntosLocal}
                                        </div>
                                        <div className="separator" >-</div>
                                        <div className="team-result">
                                            {jornada.puntosVisitante}
                                        </div>
                                    </div>
                                </div>
                                
                            </div>)
                        }
                        else if ((jornada.equipoLocal === "A.A. INMACULADA - A" && jornada.puntosVisitante>jornada.puntosLocal) ||
                            (jornada.equipoVisitante === "A.A. INMACULADA - A" && jornada.puntosLocal>jornada.puntosVisitante)){
                            return (<div className='row-result-lose' key={jornada.fecha}>
                                <div className="text-result-container">
                                    <div className="text-result">
                                        Derrota
                                    </div>
                                </div>
                                <div className="column-teams-result">
                                    <div className="date-text" >{jornada.fecha}</div>
                                    <div className="container-teams-result">
                                        <div className="team-image-result">
                                            <img src={getImagenEquipo(jornada.equipoLocal)} className="team-image" alt="escudo" />  
                                        </div>
                                        
                                        <div className="separator" >VS</div>
                                        <div className="team-image-result">
                                            <img src={getImagenEquipo(jornada.equipoVisitante)} className="team-image" alt="escudo" />  
                                        </div>
                                    </div>
                                </div>
                                <div className="number-result-container">
                                    <div className="number-result">
                                        <div className="team-result">
                                                {jornada.puntosLocal}
                                        </div>
                                        <div className="separator" >-</div>
                                        <div className="team-result">
                                            {jornada.puntosVisitante}
                                        </div>
                                    </div>
                                </div>
                                
                            </div>)
                        }
                    } 
                })}
            </div>

            <div className='section-title'>
                <div className='title'>
                    Nuestros patrocinadores
                </div>
           </div>
           <div className='sponsors-container'>
            {patrocinadores.map((patrocinador)=>{
                return (
                    <div className="sponsor-image-container">
                        <img src={patrocinador.imagenUrl} className="sponsor-image" alt="logo" />  
                    </div>
                )
            })}
           </div>
                
        </main>
    );
}